import FingerprintJS from '@fingerprintjs/fingerprintjs';

/**
 * generateFingerprint is implemented following guidelines
 * from the @fingerprintjs/fingerprintjs package documentation:
 * https://github.com/fingerprintjs/fingerprintjs/blob/master/docs/api.md
 */
async function generateFingerprint(): Promise<string | null> {
  try {
    const inRunningInUnitTests =
      typeof process === 'object' && process.env.NODE_ENV === 'test';
    // Skip fingerprint generation when running in unit tests
    if (inRunningInUnitTests) {
      return 'a-mock-visitor-id';
    }
    const fingerprint = await FingerprintJS.load();
    const result = await fingerprint.get();

    return result.visitorId;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return null;
  }
}

export default async function getFingerprint() {
  const timeout = 200;
  return new Promise<Awaited<ReturnType<typeof generateFingerprint>>>(
    (resolve) => {
      // @ts-expect-error, requestIdleCallback is not defined in all browsers, but our
      // TS config thinks it always exists.
      if (window.requestIdleCallback) {
        requestIdleCallback(
          async () => {
            const fingerprint = await generateFingerprint();
            resolve(fingerprint);
          },
          { timeout },
        );
      } else {
        setTimeout(async () => {
          const fingerprint = await generateFingerprint();
          resolve(fingerprint);
        }, timeout);
      }
    },
  );
}
